import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchDynamicSenderProjectSetting } from 'api/queries';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { useExperimentsTranslations } from './useTranslations';

const source = 'useDynamicSenderProjectSetting';

export const useDynamicSenderProjectSetting = (fetchData = true) => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const errorToasterMessage = t('errorMessage.fetchProjectSettings');
  /**
   * We need this setting just for nameAndSenderExperiment.
   * So, this flag gives us the ability to not make a
   * remote call for other types of experiment
   * */
  return fetchData
    ? () => {
        const {
          data: { currentProject } = {},
          errorMessage: error,
        } = useGraphql(fetchDynamicSenderProjectSetting);

        if (error) {
          dispatch(
            addNegativeToast(
              errorToasterMessage,
              errorIdentifier({
                source,
                error,
              }),
            ),
          );
        }

        return currentProject?.useDynamicSenders;
      }
    : () => false;
};
